import React, { useState } from "react";
import styles from "../styles/Components/header.module.sass";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown, Menu } from "antd";
import PoolData from "../pages/Auth/AWSConfig/PoolData";
import { setLogout } from "../redux/main/action/main";
import { useLocation, useNavigate } from "react-router-dom";
import Avatar from "react-avatar";
import MenuItem from "./header/MenuItem";
import InsightHelp from "./help/InsightHelp";
import AIHelp from "./help/AIHelp";
import AlertHelp from "./help/AlertHelp";
import { IoIosArrowDown } from "react-icons/io";
import HeaderNavigationMenu from "./header/HeaderNavigationMenu";
import RadarIcon from "../ui/RadarIcon";
import { MdOndemandVideo } from "react-icons/md";
import DemoModal from "./layout/DemoModal";
import TelegramIcon from "../ui/icons/TelegramIcon";
import SettingsIcon from "../ui/icons/SettingsIcon";
import HelpIcon from "../ui/icons/HelpIcon";
import LogoutIcon from "../ui/icons/LogoutIcon";

const menuData = [
  // {
  //   label: "My AI Bot",
  //   description: "Personal AI bot management",
  //   icon: bot,
  // },
  // {
  //   label: "My Integrated Exchanges",
  //   description: "Centralize crypto exchange monitoring",
  //   icon: integration,
  // },
  // {
  //   label: "My AI Signals",
  //   description: "Your personal trading advisor, powered by AI",
  //   icon: aiIcon,
  // },
  // {
  //   label: "My Insights Sessions",
  //   description: "Check insights sessions",
  //   icon: insights,
  // },
  // {
  //   label: "My Backtests",
  //   description: "Backtest trading strategies",
  //   icon: testing,
  // },
  {
    label: "Telegram Mini App",
    description: "Access and manage your Telegram bot",
    icon: <TelegramIcon />,
    key: "miniApp"
  },
  {
    label: "Settings",
    description: "Customize platform and account",
    icon: <SettingsIcon />,
    key: "settings",
  },
  {
    label: "Help",
    description: "Receive help and guidance",
    icon: <HelpIcon />,
    key: "help"
  },
  {
    label: "Logout",
    description: "Securely log out account",
    icon: <LogoutIcon />,
    key: "logout",
  },
];

const Header = () => {
  const dispatch = useDispatch();
  const {
    main: { userData },
    profile: { profileData },
    alertSystem: { telegramBotToken },
  } = useSelector((state) => state);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openAi, setOpenAi] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);

  const [openOnboardingVideo, setOpenOnboardingVideo] = useState(false);

  const location = useLocation();
  const isInDashboard = location.pathname === "/dashboard";

  const telegramLink = telegramBotToken
    ? `https://t.me/cryptocrispy_bot?start=${telegramBotToken}`
    : "https://t.me/cryptocrispy_bot";
  const handleAiOk = () => setOpenAi(false);
  const handleAiCancel = () => setOpenAi(false);
  const handleAlertOk = () => setOpenAlert(false);
  const handleAlertCancel = () => setOpenAlert(false);

  const handleOk = () => {
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };
  const handleMenuClick = (e) => {
    // eslint-disable-next-line default-case
    switch (e.key) {
      case "0":
        navigate("/bot-automation");
        break;
      case "1":
        navigate("/portfolio");
        break;
      case "2":
        navigate("/ai-assistant/assistant");
        // navigate("/insight");
        break;
      case "3":
        navigate("/insight");
        break;
      case "4":
        // navigate("/trade-simulator");
        // navigate("/ai-assistant/assistant");
        navigate("/bot-automation/backtest");
        break;
      case "miniApp":
        window.open(telegramLink, "_blank");
        break;
      case "settings":
        navigate("/profile/info");
        break;
      case "help":
        navigate("/faq/all");
        break;
      case "logout":
        dispatch(setLogout());
        const user = PoolData.getCurrentUser();
        user?.signOut();
        break;
    }
  };
  const menu = (
    <Menu
      className={styles.MenuClassName}
      style={{ left: "0" }}
      onClick={handleMenuClick}
      items={menuData.map((item) => ({
        label: (
          <MenuItem
            img={item.icon}
            description={item.description}
            title={item.label}
            icon={item.icon}
          />
        ),
        key: `${item.key}`,
      }))}
    />
  );

  return (
    <>
      <div className={styles.headerContainer}>
        <HeaderNavigationMenu />

        {/*<ThemeToggle />*/}
        <div className={styles.rightHeader}>
          {isInDashboard && <RadarIcon />}
          {isInDashboard && (
            <span
              className={styles.onboardingVideo}
              onClick={() => setOpenOnboardingVideo(true)}
            >
              <MdOndemandVideo size={20} />
            </span>
          )}
          <div className={styles.profileContainer}>
            <span>
              {profileData?.avatar_url ? (
                <img
                  className={styles.profileImg}
                  src={profileData?.avatar_url}
                  alt="profile image"
                />
              ) : (
                <Avatar
                  name={userData?.["custom:custom_username"]}
                  size="100%"
                  round={true}
                />
              )}
            </span>
            <Dropdown
              overlay={menu}
              trigger={["click"]}
              className={styles.dropDown}
            >
              <a
                onClick={(e) => e.preventDefault()}
                title={userData?.["custom:custom_username"]}
              >
                <span className={styles.userName}>
                  {userData?.["custom:custom_username"] &&
                  userData?.["custom:custom_username"].length > 10
                    ? userData?.["custom:custom_username"].slice(0, 10) + "..."
                    : userData?.["custom:custom_username"]}
                </span>
                <IoIosArrowDown />
              </a>
            </Dropdown>
          </div>
        </div>
      </div>
      <InsightHelp
        open={open}
        handleOk={handleOk}
        handleCancel={handleCancel}
      />
      <AIHelp
        open={openAi}
        handleOk={handleAiOk}
        handleCancel={handleAiCancel}
      />
      <AlertHelp
        open={openAlert}
        handleOk={handleAlertOk}
        handleCancel={handleAlertCancel}
      />

      <DemoModal
        open={openOnboardingVideo}
        handleClose={() => setOpenOnboardingVideo(false)}
        page="Onboarding"
      />
    </>
  );
};

export default Header;
